<div class="box-wrapper box-infoExtra">
    <div class="box-content-header box-content-header-infoExtra">
        <div class="row p-1">
            <div class="col">
                <mat-card-title>
                    <i class="fa-solid fa-circle-info"></i>
                    <span>Informații adiționale</span>
                </mat-card-title>
            </div>
        </div>
    </div>
    <div class="box-content-body">
        <div class="col d-flex justify-content-start p-2">
            <div class="request-filter">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onInfoChange($event)"
                    value="info">
                    <mat-button-toggle value="info">Info</mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.adresa_proprietate" value="proprietate">
                        Proprietate
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.coproprietari !== null && cerere?.coproprietari?.length !== 0"
                        value="coproprietari">
                        Coproprietari
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.imputernicit" value="imputernicit">
                        Împuternicit
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.notar" value="notar">
                        Notar
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.banca && cerere?.banca?.iban !== null" value="banca">
                        Banca
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.mandat_postal" value="mandat">
                        Mandat Poștal
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.salubrizare !== null && cerere?.salubrizare?.length !== 0"
                        value="salubrizare">
                        Salubrizare
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.adresa_nou_proprietar" value="proprietar">
                        Proprietar Nou
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.spectacole !== null && cerere?.spectacole?.length !== 0"
                        value="spectacole">
                        Spectacole
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.beneficiarpf" value="beneficiar_pf">
                        Beneficiar PF
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.beneficiarpj" value="beneficiar_pj">
                        Beneficiar PJ
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.beneficiarpjreprezentant" value="benef_pj">
                        Benef. PJ-Reprez
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.cnps !== null && cerere?.cnps?.length !== 0" value="lista_pf">
                        Listă alte cereri PF
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.cuis !== null && cerere?.cuis?.length !== 0" value="lista_pj">
                        Listă alte cereri PJ
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.taxe_records !== null && cerere?.taxe_records?.length !== 0"
                        value="taxe">
                        Taxe declarate
                    </mat-button-toggle>
                    <mat-button-toggle
                        *ngIf="cerere?.servicii_records !== null && cerere?.servicii_records?.length !== 0"
                        value="servicii">
                        Servicii declarate
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.adresa_parcare !== null" value="adresa_parcare">
                        Adresă parcare
                    </mat-button-toggle>
                    <mat-button-toggle *ngIf="cerere?.adresa_radiere !== null" value="adresa_radiere">
                        Adresă radiere
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
        <table class="table table-condensed table-wrapper-box">
            <tbody *ngIf="selectedInfoStatus === 'beneficiar_pf'">
                <tr>
                    <td class="text-center">
                        <strong>Nume</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpf?.nume }} {{cerere?.beneficiarpf?.prenume}}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Info CI/BI</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpf?.ci_serie }} | {{cerere?.beneficiarpf?.ci_numar}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpf?.cnp !== null">
                    <td class="text-center">
                        <strong>CNP</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpf?.cnp }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpf?.telefon !== null">
                    <td class="text-center">
                        <strong>Telefon</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpf?.telefon }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpf?.email !== null">
                    <td class="text-center">
                        <strong>Email</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpf?.email }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpf?.judet_name !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpf?.judet_name }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpf?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpf?.oras }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpf?.sector !== null">
                    <td class="text-center">
                        <strong>Sector</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpf?.sector }}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Adresa</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpf?.addr_web || 'n/a' }}
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'beneficiar_pj'">
                <tr *ngIf="cerere?.beneficiarpj?.cui !== null">
                    <td class="text-center">
                        <strong>Denumire</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpj?.denumire }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpj?.cui !== null">
                    <td class="text-center">
                        <strong>CUI</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpj?.cui }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpj?.telefon !== null">
                    <td class="text-center">
                        <strong>Telefon</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpj?.telefon }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpj?.email !== null">
                    <td class="text-center">
                        <strong>Email</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpj?.email }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpj?.judet_name !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpj?.judet_name }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpj?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpj?.oras }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpj?.sector !== null">
                    <td class="text-center">
                        <strong>Sector</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpj?.sector }}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Adresa</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpj?.addr_web || 'n/a' }}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Observații</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpj?.observatii || 'n/a' }}
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'benef_pj'">
                <tr>
                    <td class="text-center">
                        <strong>Nume</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpjreprezentant?.nume }} {{cerere?.beneficiarpjreprezentant?.prenume}}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Info CI/BI</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpjreprezentant?.ci_serie }} |
                        {{cerere?.beneficiarpjreprezentant?.ci_numar}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpjreprezentant?.cnp !== null">
                    <td class="text-center">
                        <strong>CNP</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpjreprezentant?.cnp }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpjreprezentant?.telefon !== null">
                    <td class="text-center">
                        <strong>Telefon</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpjreprezentant?.telefon }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpjreprezentant?.email !== null">
                    <td class="text-center">
                        <strong>Email</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpjreprezentant?.email }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpjreprezentant?.judet_name !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpjreprezentant?.judet_name }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpjreprezentant?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpjreprezentant?.oras }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.beneficiarpjreprezentant?.sector !== null">
                    <td class="text-center">
                        <strong>Sector</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpjreprezentant?.sector }}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Adresa</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.beneficiarpjreprezentant?.addr_web || 'n/a' }}
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'lista_pf'">
                <tr *ngFor="let row of cerere?.cnps; let i = index">
                    <td colspan="2">
                        <div class="row">
                            <div class="col-sm-12">
                                <button type="button" class="btn btn-xs"
                                    [ngClass]="{'btn-primary': this.viewAlteCereri === i, 'btn-light': this.viewAlteCereri !== i}"
                                    (click)="this.viewAlteCereri = i">
                                    Cerere #{{ i + 1 }}
                                </button>
                            </div>
                        </div>
                        <table class="table table-condensed table-wrapper-box" *ngIf="this.viewAlteCereri === i">
                            <tbody>
                                <tr *ngIf="row.numar_registratura !== null">
                                    <td class="text-center">
                                        <strong>Nr. cerere</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.numar_registratura }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.created_at !== null">
                                    <td class="text-center">
                                        <strong>Dată creat</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ formatCreatedAt(row.created_at) }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.subject !== 'n\/a'">
                                    <td class="text-center">
                                        <strong>Subiect</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.subject }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Nume declarat</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.nume }} {{ row.prenume }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.observatii !== null">
                                    <td class="text-center">
                                        <strong>Observații</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.observatii }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.current_status !== null">
                                    <td class="text-center">
                                        <strong>Status</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.current_status.name }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'lista_pj'">
                <tr *ngFor="let row of cerere?.cuis; let i = index">
                    <td colspan="2">
                        <div class="row">
                            <div class="col-sm-12">
                                <button type="button" class="btn btn-xs"
                                    [ngClass]="{'btn-primary': this.viewAlteCereri === i, 'btn-light': this.viewAlteCereri !== i}"
                                    (click)="this.viewAlteCereri = i">
                                    Cerere #{{ i + 1 }}
                                </button>
                            </div>
                        </div>
                        <table class="table table-condensed table-wrapper-box" *ngIf="this.viewAlteCereri === i">
                            <tbody>
                                <tr *ngIf="row.numar_registratura !== null">
                                    <td class="text-center">
                                        <strong>Nr. cerere</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.numar_registratura }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.created_at !== null">
                                    <td class="text-center">
                                        <strong>Dată creat</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ formatCreatedAt(row.created_at) }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.subject !== null">
                                    <td class="text-center">
                                        <strong>Subiect</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.subject }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Nume declarat</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.nume }} {{ row.prenume }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.observatii !== null">
                                    <td class="text-center">
                                        <strong>Observații</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.observatii }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.current_status !== null">
                                    <td class="text-center">
                                        <strong>Status</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.current_status.name }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'taxe'">
                <tr *ngFor="let row of cerere?.taxe_records; let i = index">
                    <td colspan="2">
                        <div class="row">
                            <div class="col-sm-12">
                                <button type="button" class="btn btn-xs"
                                    [ngClass]="{'btn-primary': this.viewAlteCereri === i, 'btn-light': this.viewAlteCereri !== i}"
                                    (click)="this.viewAlteCereri = i">
                                    Cerere #{{ i + 1 }}
                                </button>
                            </div>
                        </div>

                        <table class="table table-condensed table-wrapper-box" *ngIf="this.viewAlteCereri === i">
                            <tbody>
                                <tr *ngIf="row.web_name !== null">
                                    <td class="text-center">
                                        <strong>Taxa</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.web_name }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.suprafata !== null">
                                    <td class="text-center">
                                        <strong>Suprafața</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.suprafata }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.data_inceput !== null">
                                    <td class="text-center">
                                        <strong>Dată început</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ formatCreatedAt(row.data_inceput) }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.data_sfarsit !== null">
                                    <td class="text-center">
                                        <strong>Dată sfârșit</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ formatCreatedAt(row.data_sfarsit) }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.observatii !== null">
                                    <td class="text-center">
                                        <strong>Observații</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.observatii || 'n/a' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'servicii'">
                <tr *ngFor="let row of cerere?.servicii_records; let i = index">
                    <td colspan="2">
                        <div class="row">
                            <div class="col-sm-12">
                                <button type="button" class="btn btn-xs"
                                    [ngClass]="{'btn-primary': this.viewAlteCereri === i, 'btn-light': this.viewAlteCereri !== i}"
                                    (click)="this.viewAlteCereri = i">
                                    Cerere #{{ i + 1 }}
                                </button>
                            </div>
                        </div>

                        <table class="table table-condensed table-wrapper-box" *ngIf="this.viewAlteCereri === i">
                            <tbody>
                                <tr *ngIf="row.contract !== null">
                                    <td class="text-center">
                                        <strong>Contract</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.contract }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.data_inceput !== null">
                                    <td class="text-center">
                                        <strong>Dată început</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ formatCreatedAt(row.data_inceput) }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.valoare !== null">
                                    <td class="text-center">
                                        <strong>Valoare</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.valoare }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.beneficiar_name !== null">
                                    <td class="text-center">
                                        <strong>Beneficiar</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.beneficiar_name }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.luna_declaratie_name !== null">
                                    <td class="text-center">
                                        <strong>Luna</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.luna_declaratie_name }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.observatii !== null">
                                    <td class="text-center">
                                        <strong>Observații</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.observatii || 'n/a' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'info'">
                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tipSolicitant !== null && cerere?.info?.tipSolicitant !== ''">
                    <td class="text-center">
                        <strong>Tip persoană</strong>
                    </td>
                    <td class="text-left">
                        <span *ngIf="cerere?.info?.tipSolicitant == 1">
                            Persoană Fizică
                        </span>
                        <span *ngIf="cerere?.info?.tipSolicitant == 2">
                            Persoană Juridică
                        </span>
                    </td>
                </tr>
                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.calitateSolicitant !== null && cerere?.info?.calitateSolicitant !== ''">
                    <td class="text-center">
                        <strong>Calitate Solicitant</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.calitateSolicitant}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.necesitate !== null && cerere?.info?.necesitate !== ''">
                    <td class="text-center">
                        <strong>Necesitate</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.necesitate}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.observatii_necesitate !== null && cerere?.info?.observatii_necesitate !== ''">
                    <td class="text-center">
                        <strong>Obs. Necesitate</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.observatii_necesitate}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.observatii_scutire !== null && cerere?.info?.observatii_scutire !== ''">
                    <td class="text-center">
                        <strong>Obs. Scutire</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.observatii_scutire}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.numar_act_dobandire !== null && cerere?.info?.numar_act_dobandire !== ''">
                    <td class="text-center">
                        <strong>Nr. Act. Dobândire</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.numar_act_dobandire}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.data_act_dobandire !== null && cerere?.info?.data_act_dobandire !== ''">
                    <td class="text-center">
                        <strong>Dată Act Dobândire</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.data_act_dobandire}}
                    </td>
                </tr>

                <tr *ngIf="cerere?.info !== null && cerere?.info?.tip_teren !== null && cerere?.info?.tip_teren !== ''">
                    <td class="text-center">
                        <strong>Tip Teren</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_teren}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.suprafata_teren !== null && cerere?.info?.suprafata_teren !== ''">
                    <td class="text-center">
                        <strong>Suprafață teren</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.suprafata_teren}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.cota_proprietate !== null && cerere?.info?.cota_proprietate !== ''">
                    <td class="text-center">
                        <strong>Cotă proprietate</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.cota_proprietate}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.numar_cadastral !== null && cerere?.info?.numar_cadastral !== ''">
                    <td class="text-center">
                        <strong>Număr cadastral</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.numar_cadastral}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.categorie_teren !== null && cerere?.info?.categorie_teren !== ''">
                    <td class="text-center">
                        <strong>Categorie teren</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.categorie_teren}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_cladire !== null && cerere?.info?.tip_cladire !== ''">
                    <td class="text-center">
                        <strong>Tip Clădire</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_cladire}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_pereti !== null && cerere?.info?.tip_pereti !== ''">
                    <td class="text-center">
                        <strong>Tip Pereți</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_pereti}}
                    </td>
                </tr>

                <tr *ngIf="cerere?.info !== null && cerere?.info?.suprafata !== null && cerere?.info?.suprafata !== ''">
                    <td class="text-center">
                        <strong>Suprafață</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.suprafata}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.suprafata_mp !== null && cerere?.info?.suprafata_mp !== ''">
                    <td class="text-center">
                        <strong>Suprafață(mp)</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.suprafata_mp}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.cu_instalatii !== null && cerere?.info?.cu_instalatii !== ''">
                    <td class="text-center">
                        <strong>Cu instalații</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.cu_instalatii}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.valoarea_cladirii !== null && cerere?.info?.valoarea_cladirii !== ''">
                    <td class="text-center">
                        <strong>Valoarea Clădirii</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.valoarea_cladirii}}
                    </td>
                </tr>

                <tr *ngIf="cerere?.info !== null && cerere?.info?.valoare !== null && cerere?.info?.valoare !== ''">
                    <td class="text-center">
                        <strong>Valoare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.valoare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.data_conform_dobandire !== null && cerere?.info?.data_conform_dobandire !== ''">
                    <td class="text-center">
                        <strong>Data conform dobândire</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.data_conform_dobandire}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_mijloc_transport !== null && cerere?.info?.tip_mijloc_transport !== ''">
                    <td class="text-center">
                        <strong>Tip mijloc transport</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_mijloc_transport}}
                    </td>
                </tr>

                <tr *ngIf="cerere?.info !== null && cerere?.info?.hybrid !== null && cerere?.info?.hybrid !== ''">
                    <td class="text-center">
                        <strong>Hybrid</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.hybrid}}
                    </td>
                </tr>

                <tr *ngIf="cerere?.info !== null && cerere?.info?.electric !== null && cerere?.info?.electric !== ''">
                    <td class="text-center">
                        <strong>Electric</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.electric}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.data_dobandire !== null && cerere?.info?.data_dobandire !== ''">
                    <td class="text-center">
                        <strong>Dată dobândire</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.data_dobandire}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.anul_fabricatiei !== null && cerere?.info?.anul_fabricatiei !== ''">
                    <td class="text-center">
                        <strong>Anul fabricației</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.anul_fabricatiei}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.norma_poluare !== null && cerere?.info?.norma_poluare !== ''">
                    <td class="text-center">
                        <strong>Norma poluare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.norma_poluare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_mijloc_transport_tonaj !== null && cerere?.info?.tip_mijloc_transport_tonaj !== ''">
                    <td class="text-center">
                        <strong>Tip mijloc transport</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_mijloc_transport_tonaj}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_suspensie !== null && cerere?.info?.tip_suspensie !== ''">
                    <td class="text-center">
                        <strong>Tip suspensie</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_suspensie}}
                    </td>
                </tr>

                <tr *ngIf="cerere?.info !== null && cerere?.info?.marca !== null && cerere?.info?.marca !== ''">
                    <td class="text-center">
                        <strong>Marca</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.marca}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.masa_autorizata !== null && cerere?.info?.masa_autorizata !== ''">
                    <td class="text-center">
                        <strong>Masa autorizată</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.masa_autorizata}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.act_instrainare !== null && cerere?.info?.act_instrainare !== ''">
                    <td class="text-center">
                        <strong>Act înstrăinare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.act_instrainare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.data_incetare !== null && cerere?.info?.data_incetare !== ''">
                    <td class="text-center">
                        <strong>Dată încetare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.data_incetare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.categorie_scutire !== null && cerere?.info?.categorie_scutire !== ''">
                    <td class="text-center">
                        <strong>Categorie scutire</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.categorie_scutire}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_scutire !== null && cerere?.info?.tip_scutire !== ''">
                    <td class="text-center">
                        <strong>Tip Scutire</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_scutire}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.motiv_solicitare !== null && cerere?.info?.motiv_solicitare !== ''">
                    <td class="text-center">
                        <strong>Motiv Solicitare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.motiv_solicitare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.suma_solicitata !== null && cerere?.info?.suma_solicitata !== ''">
                    <td class="text-center"><strong>Suma solicitată</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.suma_solicitata}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.metoda_restituirii !== null && cerere?.info?.metoda_restituirii !== ''">
                    <td class="text-center">
                        <strong>Metoda restituirii</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.metoda_restituirii}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.an_constructie !== null && cerere?.info?.an_constructie !== ''">
                    <td class="text-center">
                        <strong>An construcție</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.an_constructie}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.valoarea_achizitiei !== null && cerere?.info?.valoarea_achizitiei !== ''">
                    <td class="text-center">
                        <strong>Dată începere</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.valoarea_achizitiei}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.data_documentului_pj !== null && cerere?.info?.data_documentului_pj !== ''">
                    <td class="text-center">
                        <strong>Dată document</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.data_documentului_pj}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.denumire_spectacol !== null && cerere?.info?.denumire_spectacol !== ''">
                    <td class="text-center">
                        <strong>Denumire spectacol</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.denumire_spectacol}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.vanzari_incasarea_biletelor !== null && cerere?.info?.vanzari_incasarea_biletelor !== ''">
                    <td class="text-center">
                        <strong>Vânzări din încasarea biletelor</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.vanzari_incasarea_biletelor}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.vanzari_contravaloarea_timbrelor !== null && cerere?.info?.vanzari_contravaloarea_timbrelor !== ''">
                    <td class="text-center">
                        <strong>Vânzări din contravaloarea timbrelor</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.vanzari_contravaloarea_timbrelor}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.sume_cedate_scopuri_umanitare !== null && cerere?.info?.sume_cedate_scopuri_umanitare !== ''">
                    <td class="text-center">
                        <strong>Sume cedate în scopuri umanitare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.sume_cedate_scopuri_umanitare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.incasari_impozitabile !== null && cerere?.info?.incasari_impozitabile !== ''">
                    <td class="text-center">
                        <strong>Încasări impozitabile</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.incasari_impozitabile}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.cota_impozit !== null && cerere?.info?.cota_impozit !== ''">
                    <td class="text-center">
                        <strong>Cotă impozit</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.cota_impozit}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.an_fabricatie !== null && cerere?.info?.an_fabricatie !== ''">
                    <td class="text-center">
                        <strong>An fabricație</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.an_fabricatie}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.destinatie_cladire !== null && cerere?.info?.destinatie_cladire !== ''">
                    <td class="text-center">
                        <strong>Destinație Clădire</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.destinatie_cladire}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_document !== null && cerere?.info?.tip_document !== ''">
                    <td class="text-center">
                        <strong>Tip document</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_document}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.luna_declaratiei !== null && cerere?.info?.luna_declaratiei !== ''">
                    <td class="text-center">
                        <strong>Luna declarației</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.luna_declaratiei}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.valoare_achizitie !== null && cerere?.info?.valoare_achizitie !== ''">
                    <td class="text-center">
                        <strong>Valoare achiziție</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.valoare_achizitie}}
                    </td>
                </tr>

                <tr *ngIf="cerere?.info !== null && cerere?.info?.locuit !== null && cerere?.info?.locuit !== ''">
                    <td class="text-center">
                        <strong>Locuit</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.locuit}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.activitati_economice !== null && cerere?.info?.activitati_economice !== ''">
                    <td class="text-center">
                        <strong>Activități Economice</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.activitati_economice}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.stare_civila !== null && cerere?.info?.stare_civila !== ''">
                    <td class="text-center">
                        <strong>Stare Civilă</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.stare_civila}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.date_identificare !== null && cerere?.info?.date_identificare !== ''">
                    <td class="text-center">
                        <strong>Date identificare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.date_identificare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_compensare !== null && cerere?.info?.tip_compensare !== ''">
                    <td class="text-center">
                        <strong>Tip compensare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_compensare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_impozit_solicitare !== null && cerere?.info?.tip_impozit_solicitare !== ''">
                    <td class="text-center">
                        <strong>Tip impozit solicitare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_impozit_solicitare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.capacitate_cilindrica !== null && cerere?.info?.capacitate_cilindrica !== ''">
                    <td class="text-center">
                        <strong>Capacitate cilindrică</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.capacitate_cilindrica}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.serie_motor !== null && cerere?.info?.serie_motor !== ''">
                    <td class="text-center">
                        <strong>Serie motor</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.serie_motor}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.serie_sasiu !== null && cerere?.info?.serie_sasiu !== ''">
                    <td class="text-center">
                        <strong>Serie Șasiu</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.serie_sasiu}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.numar_inmatriculare !== null && cerere?.info?.numar_inmatriculare !== ''">
                    <td class="text-center">
                        <strong>Număr Înmatriculare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.numar_inmatriculare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.proces_verbal_amenda !== null && cerere?.info?.proces_verbal_amenda !== ''">
                    <td class="text-center">
                        <strong>PV Amendă</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.proces_verbal_amenda}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.proces_verbal_amenda_data !== null && cerere?.info?.proces_verbal_amenda_data !== ''">
                    <td class="text-center">
                        <strong>PV Data Amendă</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.proces_verbal_amenda_data}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.numar_document_plata !== null && cerere?.info?.numar_document_plata !== ''">
                    <td class="text-center">
                        <strong>Nr. document plată</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.numar_document_plata}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.numar_document_plata_data !== null && cerere?.info?.numar_document_plata_data !== ''">
                    <td class="text-center">
                        <strong>Dată document plată</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.numar_document_plata_data}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_amenda !== null && cerere?.info?.tip_amenda !== ''">
                    <td class="text-center">
                        <strong>Tip amendă</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_amenda}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_amplasament !== null && cerere?.info?.tip_amplasament !== ''">
                    <td class="text-center">
                        <strong>Tip amplasament</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_amplasament}}
                    </td>
                </tr>

                <tr *ngIf="cerere?.info !== null && cerere?.info?.tip_moped !== null && cerere?.info?.tip_moped !== ''">
                    <td class="text-center">
                        <strong>Tip moped</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_moped}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.tip_rectificare !== null && cerere?.info?.tip_rectificare !== ''">
                    <td class="text-center">
                        <strong>Tip rectificare</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.tip_rectificare}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.data_inceput !== null && cerere?.info?.data_inceput !== ''">
                    <td class="text-center">
                        <strong>Dată început</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.data_inceput}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.data_sfarsit !== null && cerere?.info?.data_sfarsit !== ''">
                    <td class="text-center">
                        <strong>Dată sfârșit</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.data_sfarsit}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.durata_luni !== null && cerere?.info?.durata_luni !== ''">
                    <td class="text-center">
                        <strong>Durată luni</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.durata_luni}}
                    </td>
                </tr>

                <tr
                    *ngIf="cerere?.info !== null && cerere?.info?.durata_zile !== null && cerere?.info?.durata_zile !== ''">
                    <td class="text-center">
                        <strong>Durată zile</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.info?.durata_zile}}
                    </td>
                </tr>

                <tr *ngIf="cerere?.description !== ''">
                    <td class="text-center">
                        <strong>Observații cerere</strong>
                    </td>
                    <td class="text-left">
                        <span [innerHTML]="cerere?.description"></span>
                    </td>
                </tr>
                <tr *ngIf="cerere?.info?.observatii">
                    <td class="text-center">
                        <strong>Observații</strong>
                    </td>
                    <td class="text-left">
                        <span [innerHTML]="cerere?.info?.observatii"></span>
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'proprietate'">
                <tr *ngIf="cerere?.adresa_proprietate?.judet !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_proprietate?.judet_name }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_proprietate?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_proprietate?.oras }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_proprietate?.sector !== null">
                    <td class="text-center">
                        <strong>Sector</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_proprietate?.sector }}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Adresa</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_proprietate?.addr_web || 'n/a' }}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Observații</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_proprietate?.observatii || 'n/a' }}
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'adresa_parcare'">
                <tr *ngIf="cerere?.adresa_parcare?.judet !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_parcare?.judet_name }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_parcare?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_parcare?.oras }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_parcare?.sector !== null">
                    <td class="text-center">
                        <strong>Sector</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_parcare?.sector }}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Adresa</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_parcare?.addr_web || 'n/a' }}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Observații</strong>
                    </td>
                    <td class="test-left">
                        {{ cerere?.adresa_parcare?.observatii || 'n/a' }}
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'coproprietari'">
                <tr *ngFor="let row of cerere?.coproprietari; let i = index">
                    <td colspan="2">
                        <div class="row">
                            <div class="col-sm-12">
                                <button type="button" class="btn btn-xs"
                                    [ngClass]="{'btn-primary': this.viewAlteCereri === i, 'btn-light': this.viewAlteCereri !== i}"
                                    (click)="this.viewAlteCereri = i">
                                    CO #{{ i + 1 }}
                                </button>
                            </div>
                        </div>

                        <table class="table table-condensed table-wrapper-box" *ngIf="this.viewAlteCereri === i">
                            <tbody>
                                <tr>
                                    <td class="text-center">
                                        <strong>Nume</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.nume }} {{ row.prenume }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Info CI/BI</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.ci_serie }} | {{ row.ci_numar }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.cnp !== null">
                                    <td class="text-center">
                                        <strong>CNP</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.cnp }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.telefon !== null">
                                    <td class="text-center">
                                        <strong>Telefon</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.telefon }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.email !== null">
                                    <td class="text-center">
                                        <strong>Email</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.email }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.judet_name !== null">
                                    <td class="text-center">
                                        <strong>Județ</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.judet_name }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.oras !== null">
                                    <td class="text-center">
                                        <strong>Oraș</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.oras }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.sector !== null">
                                    <td class="text-center">
                                        <strong>Sector</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.sector || 'n/a' }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.addr_web !== null">
                                    <td class="text-center">
                                        <strong>Adresa</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.addr_web }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.observatii !== null">
                                    <td class="text-center">
                                        <strong>Observații</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.observatii || 'n/a' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'imputernicit'">
                <tr>
                    <td class="text-center">
                        <strong>Nume</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.imputernicit?.nume}} {{cerere?.imputernicit?.prenume}}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Info CI/BI</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.imputernicit?.ci_serie }} | {{cerere?.imputernicit?.ci_numar}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.imputernicit?.cnp !== null">
                    <td class="text-center">
                        <strong>CNP</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.imputernicit?.cnp }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.imputernicit?.telefon !== null">
                    <td class="text-center">
                        <strong>Telefon</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.imputernicit?.telefon }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.imputernicit?.email !== null">
                    <td class="text-center">
                        <strong>Email</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.imputernicit?.email }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.imputernicit?.judet_name !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.imputernicit?.judet_name }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.imputernicit?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.imputernicit?.oras }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.imputernicit?.sector !== null">
                    <td class="text-center">
                        <strong>Sector</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.imputernicit?.sector }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.imputernicit?.addr_web !== null">
                    <td class="text-center">
                        <strong>Adresa</strong>
                    </td>
                    <td class="text-left">
                        {{ cerere?.imputernicit?.addr_web || 'n/a' }}
                    </td>
                </tr>
                <tr *ngIf="cerere?.imputernicit?.observatii !== null">
                    <td class="text-center">
                        <strong>Observații</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.imputernicit?.observatii || 'n/a'}}
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'notar'">
                <tr *ngIf="cerere?.notar?.denumire !== null">
                    <td class="text-center">
                        <strong>Denumire</strong>
                    </td>
                    <td class="text-left">{{ cerere?.notar?.denumire }}</td>
                </tr>
                <tr *ngIf="cerere?.notar?.cui !== null">
                    <td class="text-center">
                        <strong>CUI</strong>
                    </td>
                    <td class="text-left">{{ cerere?.notar?.cui }}</td>
                </tr>
                <tr *ngIf="cerere?.notar?.telefon !== null">
                    <td class="text-center">
                        <strong>Telefon</strong>
                    </td>
                    <td class="text-left">{{ cerere?.notar?.telefon }}</td>
                </tr>
                <tr *ngIf="cerere?.notar?.email !== null">
                    <td class="text-center">
                        <strong>Email</strong>
                    </td>
                    <td class="text-left">{{ cerere?.notar?.email }}</td>
                </tr>
                <tr *ngIf="cerere?.notar?.judet_name !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="text-left">{{ cerere?.notar?.judet_name }}</td>
                </tr>
                <tr *ngIf="cerere?.notar?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș</strong>
                    </td>
                    <td class="text-left">{{ cerere?.notar?.oras }}</td>
                </tr>
                <tr *ngIf="cerere?.notar?.sector !== null">
                    <td class="text-center">
                        <strong>Sector</strong>
                    </td>
                    <td class="text-left">{{ cerere?.notar?.sector }}</td>
                </tr>
                <tr *ngIf="cerere?.notar?.addr_web !== null">
                    <td class="text-center">
                        <strong>Adresa</strong>
                    </td>
                    <td class="text-left">{{ cerere?.notar?.addr_web || 'n/a' }}</td>
                </tr>
                <tr *ngIf="cerere?.notar?.observatii !== null">
                    <td class="text-center">
                        <strong>Observații</strong>
                    </td>
                    <td class="text-left">{{ cerere?.notar?.observatii || 'n/a' }}</td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'banca'">
                <tr>
                    <td class="text-center">
                        <strong>IBAN:</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.banca?.iban}}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Banca:</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.banca?.banca}}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Sucursala:</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.banca?.sucursala}}
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'mandat'">
                <tr *ngIf="cerere?.mandat_postal?.judet_name !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.mandat_postal?.judet_name}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.mandat_postal?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.mandat_postal?.oras}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.mandat_postal?.sector !== null">
                    <td class="text-center">
                        <strong>Sector</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.mandat_postal?.sector}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.mandat_postal?.addr_web !== null">
                    <td class="text-center">
                        <strong>Adresa</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.mandat_postal?.addr_web || 'n/a'}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.mandat_postal?.observatii !== null">
                    <td class="text-center">
                        <strong>Observații</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.mandat_postal?.observatii || 'n/a'}}
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'salubrizare'">
                <tr *ngFor="let row of cerere?.salubrizare">
                    <td class="text-center">
                        <strong>{{row.month_id}}</strong>
                    </td>
                    <td class="text-left">
                        {{ row.value || '0' }}
                        <span *ngIf="cerere?.id_cetatean_type == 1">persoane</span>
                        <span *ngIf="cerere?.id_cetatean_type == 2">mc</span>
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'proprietar'">
                <tr *ngIf="cerere?.adresa_nou_proprietar?.solicitant == null">
                    <td class="text-center">
                        <strong>Cetățean</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.nume}} {{cerere?.adresa_nou_proprietar?.prenume}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_nou_proprietar?.solicitant !== null">
                    <td width="40%" class="text-center">
                        <strong>Solicitant</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.solicitant}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_nou_proprietar?.solicitant == null">
                    <td class="text-center">
                        <strong>Denumire Companie</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.denumire || 'n/a'}}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>CNP/CUI</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.cnp}} {{cerere?.adresa_nou_proprietar?.cui}}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Tip Document</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.tip_document_denumire || 'n/a'}}
                    </td>
                </tr>
                <tr>
                    <td class="text-center">
                        <strong>Serie/Număr Document</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.ci_serie || 'n/a'}} - {{cerere?.adresa_nou_proprietar?.ci_numar
                        || 'n/a'}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_nou_proprietar?.judet_name !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.judet_name}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_nou_proprietar?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.oras}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_nou_proprietar?.sector !== null">
                    <td class="text-center">
                        <strong>Sector</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.sector}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_nou_proprietar?.addr_web !== null">
                    <td class="text-center">
                        <strong>Adresa</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.addr_web || 'n/a'}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_nou_proprietar?.email !== null">
                    <td class="text-center">
                        <strong>Email</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.email || 'n/a'}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_nou_proprietar?.telefon !== null">
                    <td class="text-center">
                        <strong>Telefon</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.telefon || 'n/a'}}
                    </td>
                </tr>
                <tr *ngIf="cerere?.adresa_nou_proprietar?.observatii !== null">
                    <td class="text-center">
                        <strong>Observații</strong>
                    </td>
                    <td class="text-left">
                        {{cerere?.adresa_nou_proprietar?.observatii || 'n/a'}}
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'spectacole'">
                <tr *ngFor="let row of cerere?.spectacole; let i = index">
                    <td colspan="2">
                        <div class="row">
                            <div class="col-sm-12">
                                <button type="button" class="btn btn-xs"
                                    [ngClass]="{'btn-primary': this.viewAlteCereri === i, 'btn-light': this.viewAlteCereri !== i}"
                                    (click)="this.viewAlteCereri = i">
                                    Show #{{ i + 1 }}
                                </button>
                            </div>
                        </div>

                        <table class="table table-condensed table-wrapper-box" *ngIf="this.viewAlteCereri === i">
                            <tbody>
                                <tr>
                                    <td class="text-center">
                                        <strong>Fel și număr document</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.fel_document_bilete }} {{ row.numar_document_bilete }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.total_bilete !== null">
                                    <td class="text-center">
                                        <strong>Total bilete/abon</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.total_bilete }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.tarif_bilete !== null">
                                    <td class="text-center">
                                        <strong>Tarif</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.tarif_bilete }} RON/buc
                                    </td>
                                </tr>
                                <tr *ngIf="row.valoare_totala_bilete !== null">
                                    <td class="text-center">
                                        <strong>Valoare totală</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.valoare_totala_bilete }} RON
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Serii bilete</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.serie_bilete }} | {{ row.numar_inceput_bilete }} - {{
                                        row.numar_sfarsit_bilete }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Durata</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.data_inceput }} - {{ row.data_sfarsit }}
                                    </td>
                                </tr>
                                <tr *ngIf="row.necesitate_bilete !== null">
                                    <td class="text-center">
                                        <strong>Necesitate</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ row.necesitate_bilete }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>

            <tbody *ngIf="selectedInfoStatus === 'adresa_radiere'">
                <tr *ngIf="cerere?.adresa_radiere?.judet_name !== null">
                    <td class="text-center">
                        <strong>Județ</strong>
                    </td>
                    <td class="text-left">{{ cerere?.adresa_radiere?.judet_name }}</td>
                </tr>

                <tr *ngIf="cerere?.adresa_radiere?.oras !== null">
                    <td class="text-center">
                        <strong>Oraș/Municipiu/Comună/Sat</strong>
                    </td>
                    <td class="text-left">{{ cerere?.adresa_radiere?.oras }}</td>
                </tr>

                <tr *ngIf="cerere?.adresa_radiere?.strada !== null">
                    <td class="text-center">
                        <strong>Strada</strong>
                    </td>
                    <td class="text-left">{{ cerere?.adresa_radiere?.strada }}</td>
                </tr>

                <tr *ngIf="cerere?.adresa_radiere?.numar !== null">
                    <td class="text-center">
                        <strong>Număr</strong>
                    </td>
                    <td class="text-left">{{ cerere?.adresa_radiere?.numar }}</td>
                </tr>

                <tr *ngIf="cerere?.adresa_radiere?.bloc !== null">
                    <td class="text-center">
                        <strong>Bloc</strong>
                    </td>
                    <td class="text-left">{{ cerere?.adresa_radiere?.bloc }}</td>
                </tr>

                <tr *ngIf="cerere?.adresa_radiere?.scara !== null">
                    <td class="text-center">
                        <strong>Scara</strong>
                    </td>
                    <td class="text-left">{{ cerere?.adresa_radiere?.scara }}</td>
                </tr>

                <tr *ngIf="cerere?.adresa_radiere?.etaj !== null">
                    <td class="text-center">
                        <strong>Etaj</strong>
                    </td>
                    <td class="text-left">{{ cerere?.adresa_radiere?.etaj }}</td>
                </tr>

                <tr *ngIf="cerere?.adresa_radiere?.apartament !== null">
                    <td class="text-center">
                        <strong>Apartament</strong>
                    </td>
                    <td class="text-left">{{ cerere?.adresa_radiere?.apartament }}</td>
                </tr>

                <tr *ngIf="cerere?.adresa_radiere?.observatii !== null">
                    <td class="text-center">
                        <strong>Observații</strong>
                    </td>
                    <td class="text-left">{{ cerere?.adresa_radiere?.observatii }}</td>
                </tr>
            </tbody>

            <!-- <tbody *ngIf="selectedBeneficiaryInfoStatus === 'adresa'">

            </tbody> -->
        </table>
    </div>
</div>